import React, {useState, useEffect, useMemo, useRef} from "react";
import "./App.css";
import {ReadHebrewText, TextForm2FlatText, localStorageSetItem, localStorageGetItem} from "./misc"
import {useLessons, useExInfo} from "./DataContext";
import {useStats} from "./StatsContext";
import {removeNekudot} from "./nekudot"
import {useServer} from "./ServerContext";

const WordDisplay = ({texts2Display, onBack}) => {


    console.log("WORD",texts2Display)

    console.log("WORD VOC1",texts2Display.originalContent.filter(w => w.lesson === texts2Display.selectedLessonsList[texts2Display.selectedLessonsList.length-1])
        .flatMap(w => Object.values(w.formes).map(fw => fw[3])).reduce((acc,w) => acc+" "+w,""))

    console.log("WORD VOC2",texts2Display.originalContent.filter(w => w.lesson !== texts2Display.selectedLessonsList[texts2Display.selectedLessonsList.length-1])
        .flatMap(w => Object.values(w.formes).map(fw => fw[3])).reduce((acc,w) => acc+" "+w,""))


    // Some useful imports */
    const {allLessons, mergeWords} = useLessons();

    const {exInfoList,exFilterTexts} = useExInfo();
    const {getWordScores,removeTextsFromStats} = useStats();
    const {statsRender} = useServer()

    const needsCensorUpdate = useRef(false);

        // Managing displayed lessons (if -1 --> all are selected)
    const [selectedLesson, setSelectedLesson] = useState(
        texts2Display.selectedLessonsList.length === 1
            ? texts2Display.selectedLessonsList[0]
            : -1);

    // Managing exercise focus
    const [selectedExercise, setSelectedExercise] = useState(0);
    const exList = useMemo(() =>
        exInfoList.current.flatMap(info =>
            (!("WordScoreMenuItem" in info) ||
                    ("lessonsExcept" in info && info.lessonsExcept.includes(selectedLesson)) ||
                        ("lessonsOnly" in info && !info.lessonsOnly.includes(selectedLesson))
                ? []
                : info.WordScoreMenuItem.map((wsmi, index) => {
                    return {exInfo: info, wsmi: wsmi, choiceIndex: index, mode: info.mode, getInfo: info.getInfo}
                })
            )
        ), [selectedLesson,exInfoList]
    )

    const [selectedCensoring, setSelectedCensoring] = useState('u');

    // Managing if forget words
    const onForgetWords = () => {
        removeTextsFromStats("words", exList[selectedExercise].exInfo.group, texts);
    }



    const [forceUpdate, setForceUpdate] = useState(0);



    // Managing displayed categories (if -1 --> all are selected)
    const [selectedCategories, setSelectedCategories] = useState(-1);

    // The words to be displayed (after being filtered by lesson, censoring, categories)
    const [texts, setTexts] = useState([]);

    const [allCategories, setAllCategories ] = useState([])
    useEffect(() => {
        const set = new Set(texts2Display.originalContent.map(w => w.cat[0]))
        setAllCategories([...set].sort())
        setSelectedCategories(-1)
    }, [])


    useEffect(() => {
        let texts1 = (selectedLesson !== -1 && allLessons && !('allwords' in allLessons?.[selectedLesson])
                ? texts2Display.originalContent.filter(w => selectedLesson === w.lesson)
                : [...texts2Display.originalContent]
        );
        texts1 = exFilterTexts(exList[selectedExercise].exInfo, exList[selectedExercise].choiceIndex, texts1);
        // Adding merged words if needed from different lessons
        if (texts1.length !== 0 && selectedLesson === -1) {
            const mergedWords = mergeWords(texts1);
            texts1.push(...mergedWords)
        }

        setTexts((selectedCategories !== -1
                ? texts1.filter(w => w.cat.includes(allCategories[selectedCategories]))
                : texts1
        ));
    }, [selectedLesson, selectedCensoring, selectedCategories, selectedExercise,forceUpdate,
    allCategories,allLessons,exFilterTexts,exList,texts2Display.originalContent])

    // Managing whether nequdots should be displayed
    const [displayNequdot, setdisplayNequdot] = useState(() => {
        return JSON.parse(localStorageGetItem('wordDisplayDisplayNequdot')) || false;
    });
    useEffect(() => {
        localStorageSetItem('wordDisplayDisplayNequdot', displayNequdot);
    }, [displayNequdot]);
    const handleNequdotToggle = () => {
        setdisplayNequdot(prevState => !prevState);
    };

    // Managing the forms of the words that are opened
    const [openGroups, setOpenGroups] = useState({});
    const toggleGroup = (id) => {
        setOpenGroups((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    // Reordering forms to have the infinitive first for verbs
    const reorderForms = (textForms) => {
        let keys = Object.keys(textForms);
        if (keys.includes("inf")) {
            keys = ["inf"].concat(keys.filter(f => f !== "inf"));
        }
        else if (keys.includes("ms")) {
            keys = ["ms"].concat(keys.filter(f => f !== "ms"));
        }
        return keys;
    }

    const getWordScores_ = (word) => {
        const exInfo = exList[selectedExercise].exInfo;
        return getWordScores(word,exInfo?.modes ? exInfo.modes[exList[selectedExercise].choiceIndex] : exInfo.group);
    }

    //
    // MANAGING SORTING OF THE ARRAY
    //

    const [colSorted, setColSorted] = useState({col: 'french', dir: 0});
    const sortWords = () => {
        if (colSorted.col === 'french') {
            if (colSorted.dir === 1)
                texts.sort((t1, t) => Object.values(t.formes)[0][2].localeCompare(Object.values(t1.formes)[0][2]))
            else
                texts.sort((t, t1) => Object.values(t.formes)[0][2].localeCompare(Object.values(t1.formes)[0][2]))
        }
        if (colSorted.col === 'hebrew') {
            if (colSorted.dir === 1)
                texts.sort((t1, t) => Object.values(t.formes)[0][3].localeCompare(Object.values(t1.formes)[0][3]))
            else
                texts.sort((t, t1) => Object.values(t.formes)[0][3].localeCompare(Object.values(t1.formes)[0][3]));
        }
        if (colSorted.col === 'lesson') {
            if (colSorted.dir === 1)
                texts.sort((t1, t) => t.lesson - t1.lesson)
            else
                texts.sort((t, t1) => t.lesson - t1.lesson)
        }
        if (colSorted.col === 'score') {
            if (colSorted.dir === 1)
                texts.sort((t, t1) => (getWordScores_(t)[0] - getWordScores_(t1)[0]));
            else
                texts.sort((t1, t) => (getWordScores_(t)[0] - getWordScores_(t1)[0]));
        }
    }
    sortWords();
    useEffect(() => {
        sortWords();
    }, [colSorted])
    const onChangeSort = (col) => {
        setColSorted(colSorted.col === col
            ? {col:col, dir:1 - colSorted.dir}
            : {col:col, dir:0})
    }
    const getArrow = (col) => {
        if (colSorted.col !== col) return "";
        return colSorted.dir === 1 ? "▲" : "▼";
    }

    const onLeave = () => {
        onBack();
    }

    /*
     * RENDERING
     */

    //  style={{backgroundColor: isTextCensored(word) ? "transparent" : getColorFromScore(getWordScores(word)[0])}}
    return (
        <div className="main-container word-display">
            <div className="title-container top">
                <button className="button-secondary" onClick={() => {
                    onLeave();
                }}> ⬅️
                </button>
                <div className="title-container-title">
                    Vocabulaire
                </div>
            </div>


            <div className="section-container">

                                <div className={"section-container-line"}>

                {/* MENU SELECTED LESSON */}
                <select value={selectedLesson}
                        id={"selected-lesson-select"}
                        onChange={(e) => setSelectedLesson(Number(e.target.value))}
                >
                    {texts2Display.selectedLessonsList.length > 1
                        ? <option key={-1} value={-1}>
                            {"Toutes les leçons jusqu'à " + allLessons?.[texts2Display.selectedLessonsList[texts2Display.selectedLessonsList.length - 1]]?.course}
                        </option>
                        : null
                    }
                    {texts2Display.selectedLessonsList.map((lecon, index) => {
                        return (
                                <option key={texts2Display.selectedLessonsList[index]}
                                        value={texts2Display.selectedLessonsList[index]}>
                                    {allLessons?.[texts2Display.selectedLessonsList[index]]?.title}
                                </option>
                            )
                        }

                    )}
                </select>
                                </div>

                <div className={"section-container-line"}>

                    {/* MENU SELECTED CATEGORIES */}
                    <select className={"filtering-element"} value={selectedCategories}
                            onChange={(e) => setSelectedCategories(Number(e.target.value))}>
                        <option key={-1} value={-1}>
                            Toutes cat.
                        </option>
                        {allCategories.map((value, index) => (
                            <option key={index} value={index}>
                                {allCategories[index]}
                            </option>
                        ))}
                    </select>
                    {/* MENU EXERCISE FILTERING */}
                    <select className={"filtering-element"} value={selectedExercise}
                            onChange={(e) => setSelectedExercise(Number(e.target.value))}>
                        {exList.map((value, index) => (
                            <option key={index} value={index}>
                                {exList[index].wsmi}
                            </option>
                        ))}
                    </select>

                        {/* NEQUDOT BUTTON */}
                        <button className={"filtering-element nequdot"} onClick={handleNequdotToggle}>
                            {!displayNequdot ? "נקדות" : "נְקֻדּוֹת"}
                        </button>

                        {/* FORGET BUTTON */}
                        <button onClick={onForgetWords}  className={"filtering-element"}>
                            🔁
                        </button>
                </div>


                {/* THE MAIN TABLE */}
                <div className="table-container">

                    {/* HEADER */}
                    <div className={"table-header"}>
                        <div style={{cursor: "pointer", textAlign: "left"}}
                            onClick={() => onChangeSort("french")}>
                             {getArrow("french")} Français
                        </div>
                        <div style={{cursor: "pointer", textAlign: "right"}}
                            onClick={() => onChangeSort("hebrew")} >
                            {getArrow("hebrew")}  עברית
                        </div>
                        <div style={{cursor: "pointer", textAlign: "center"}}
                            onClick={() => onChangeSort("score")} >
                            {getArrow("score")} score
                        </div>
                    </div>

                    {/* BODY */}
                    <div className="table-body">
                        {(selectedLesson === -1
                            ? texts.filter(w => !("mergekey" in w))
                            : texts)
                            .map((word, index) => (
                            <React.Fragment key={index}>
                                <div className={"table-row "}

                                     onClick={() => ReadHebrewText(word.formes[reorderForms(word.formes)[0]][3])}
                                >
                                    <div style={{textAlign: "left"}}>
                                        {reorderForms(word.formes).length > 1 ? (
                                            <span className={`arrow ${openGroups[index] ? 'open' : ''}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleGroup(index);
                                                }}
                                            >
                                                ▶
                                            </span>
                                        ) : null}
                                        {word.formes[reorderForms(word.formes)[0]][2]}
                                    </div>
                                    <div style={{textAlign: "right"}}
                                         dir="rtl"> {
                                        (displayNequdot
                                            ? word.formes[reorderForms(word.formes)[0]][3]
                                            : removeNekudot(word.formes[reorderForms(word.formes)[0]][3])) + " " +
                                    (word.cat.includes("nom c.") || word.cat.includes("nom p.") ? "(" + reorderForms(word.formes)[0].slice(0, 1) + ") " : "")}
                                    </div>
                                    <div className={"worddisplay-score"} key={statsRender} style={{textAlign: "center"}}>
                                        {Math.round(getWordScores_(word)[0]*10)/10}
                                    </div>
                                </div>
                                {reorderForms(word.formes).length > 1 && openGroups[index] &&
                                    reorderForms(word.formes).map((form, subIndex) => {
                                        const flatWord = word.formes[form];
                                        const flatWordExt = (word.cat.includes("verbe") ? TextForm2FlatText(word, form) : flatWord)
                                        return (
                                            <div
                                                className={"table-row sub-row "}
                                                key={`${index}-${subIndex}`}
                                                onClick={() => ReadHebrewText(flatWordExt[3])}
                                            >
                                                <div
                                                    style={{
                                                        paddingLeft: ".5rem",
                                                        textAlign: "left"
                                                    }}>{flatWordExt[2]}</div>
                                                <div>{displayNequdot ? flatWordExt[3] : removeNekudot(flatWordExt[3])}</div>
                                                <div key={statsRender}>  { Math.round(getWordScores_(word)[1][form]*10)/10}</div>
                                            </div>
                                        );
                                    })}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WordDisplay;